module.exports = __webpack_public_path__ + "img/10.4fd11c26.png";